import CouponCodeExpiredModal from '@/components/coupon-modals/errors/CouponCodeExpiredModal';
import ServerErrorModal from '@/components/coupon-modals/errors/ServerErrorModal';
import { DateTime } from 'luxon';

export default {
    props: ['campaign', 'company', 'companyImages'],
    components: { CouponCodeExpiredModal, ServerErrorModal },

    data () {
        return {
            couponCode: null,
            codeCopied: false,
        }
    },

    computed: {
        webshopLink () {
            if (this.campaign.url) {
                return this.prependProtocol(this.campaign.url);
            }

            if (this.company.webshops && this.company.webshops.length && this.company.webshops[0].url) {
                return this.prependProtocol(this.company.webshops[0].url);
            }

            return null;
        },
    },

    methods: {
        formatDate(date) {
            return DateTime.fromISO(date).toISODate();
        },

        prependProtocol(url) {
            if (url && !url.startsWith('https://') && !url.startsWith('http://')) {
                return `http://${url}`;
            }

            return url;
        },

        copyCode () {
            this.copyTextToClipboard(this.couponCode);
        },

        handleClaimCouponCodeError (error) {
            if ([404, 500].includes(error.response.status)) {
                this.handleServerError();
            }

            if (error.response.data.message === 'expired') {
                this.handleCouponCodeExpired();
            }
        },

        handleServerError () {
            $('.modal').modal('hide');
            $('#serverErrorModal').modal('show');
        },

        handleCouponCodeExpired () {
            $('.modal').modal('hide');
            $('#couponCodeExpiredModal').modal('show');
        },

        fallbackCopyTextToClipboard(text) {
            var textArea = document.createElement("textarea");
            textArea.value = text;

            // Avoid scrolling to bottom
            textArea.style.top = "0";
            textArea.style.left = "0";
            textArea.style.position = "fixed";

            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();

            try {
                var successful = document.execCommand('copy');
                var msg = successful ? 'successful' : 'unsuccessful';
                console.log('Fallback: Copying text command was ' + msg);
            } catch (err) {
                console.error('Fallback: Oops, unable to copy', err);
            }

            document.body.removeChild(textArea);
        },

        copyTextToClipboard(text) {
            if (!navigator.clipboard) {
                this.fallbackCopyTextToClipboard(text);
                return;
            }

            navigator.clipboard.writeText(text).then(() => {
                this.codeCopied = true;
            }, (err) => {
                console.error('Async: Could not copy text: ', err);
            });
        }
    }
}
